module.exports = __webpack_public_path__ + "img/g-lol.57acbed.svg";